export default __webpack_public_path__ + "static/media/fairAtt.9979a994.svg";